const PREFIX_AUTHORIZATION_TOKEN = 'Token token=';

export { PREFIX_AUTHORIZATION_TOKEN };
